import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const KyushaMailFormatKbn = props => {
  return <Dropdown.Static kubunKey='kyusha_mail_format_kbn' {...props} />
}
